import { setDocumentationDetail } from '../../action';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = null;

export default createReducer(
  [forAction(setDocumentationDetail, identityPayload)],
  initialState,
);
